<sbnb-apps-detail-page
  vendorCode="ownercenter"
  name="Ownercenter"
  logoTile="/assets/images/apps/ownercenter.png"
  builtBy="Ownercenter"
  builtByLink="https://ownercenter.net/"
  [categories]="['Owner tools']"
  [permissions]="[
    AppPermission.calendarRead,
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead
  ]"
  email="support@ownercenter.net"
  [beta]="false"
  [helpArticles]="[
    {
      id: '8977105',
      title: 'Connecting Hospitable with Ownercenter'
    }
  ]">
  <section fxLayout fxLayoutGap="36px" fxLayout.lt-lg="column" class="ownercenter-content">
    <div fxFlex>
      <h4>Automations</h4>
      <span>
        Automations empower you to send automated emails to owners triggered by specific events, such as booking
        confirmations.
      </span>

      <h4>Automatic Statements & Invoices</h4>

      <span>
        This feature automates the creation and delivery of owner statements and invoices at intervals of your choice
        (Weekly, Bi-Weekly, Monthly, or Yearly). You can also include canceled bookings and expenses in these documents.
      </span>

      <h4>Owner Calendars</h4>

      <span>
        Owner Center enhances the owner calendar with various viewing options, including Multi-Calendar, Standard
        Calendar and Rates Calendar, offering flexibility in managing bookings and property availability.
      </span>

      <h4>Advanced Reporting Tool</h4>

      <span>
        Owner Center offers an advanced reporting tool with a custom user portal, allowing owners to access and analyze
        detailed performance data for their short term rental properties.
      </span>

      <h4>Customized Privileges</h4>

      <span>
        Owner Center enables property managers to customize privileges for each owner, ensuring that access and control
        are tailored to individual preferences and requirements.
      </span>

      <h4>Branded Invoices</h4>

      <span>
        Owner Center allows you to fully brand owner invoices with your company logo, providing a professional and
        personalized touch to financial documents.
      </span>

      <h4>Custom Payout Rules</h4>

      <span>
        Property managers have the flexibility to set custom payout rules, ensuring that owners receive payments
        according to their unique financial agreements.
      </span>
    </div>
    <div fxFlex>
      <iframe
        style="border-radius: 12px"
        width="100%"
        height="315"
        src="https://www.youtube.com/embed/x2LirI1xTmQ?si=HLFpP9k3E4DFcSZj"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen></iframe>
    </div>
  </section>
  <p description>
    Simplify Owner Management - create owner invoices, statements, booking reports and collect payments.
  </p>
</sbnb-apps-detail-page>
